/**
 * Landing Page
 * Main landing page combining all sections
 */
import React from 'react';

import HeroSection from '../components/HeroSection';
import QuickActions from '../components/QuickActions';
import ServicesSection from '../components/ServicesSection';
import PartnersSection from '../components/PartnersSection';
import MobileAppSection from '../components/MobileAppSection';

/**
 * Landing Page Component
 * @returns {JSX.Element} Landing page with all sections
 */
const LandingPage = () => {
  return (
    <div className="landing-page">
      <HeroSection />
      <QuickActions />
      <ServicesSection />
      <PartnersSection />
      <MobileAppSection />
    </div>
  );
};

export default LandingPage;
